<template>
  <div class="recent-orders home">
    <Navbar></Navbar>
    <mini-cart></mini-cart>
    <recent-orders></recent-orders>
  </div>
</template>

<script>
import Navbar from "../../../components/public/common/Navbar";
import MiniCart from "../../../components/public/cart/MiniCart";
import RecentOrders from "../../../components/public/recents/RecentOrders";

export default {
  name: "recent",
  components: {
    Navbar,
    MiniCart,
    RecentOrders
  }
};
</script>

<style></style>
